/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

function ExpiredFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Checkbox
        checked={value === 'true'}
        id="expired_filter"
        label={intl.formatMessage({
          id: 'expired',
          defaultMessage: 'Expiré'
        })}
        name="expired"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
    </Filter>
  )
}

export default ExpiredFilter
